<template>
  <NuxtLayout name="default">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  import type { ILocale } from '@skeleton/core/types';
  import { EnvName } from '@skeleton/consts/app';

  const { currentLocale, locales } = storeToRefs(useGlobalStore());
  const { origin } = useRequestURL();
  const route = useRoute();

  const {
    public: { appMode },
  } = useRuntimeConfig();

  const getPageLink = (locale: ILocale): string => {
    const routerLocale: any = route.params.locale;
    const pathRegexp = new RegExp(`^/${routerLocale}/|^/${routerLocale}$`);
    const pathWithoutLocale = routerLocale ? route.fullPath.replace(pathRegexp, '/') : route.fullPath;

    if (locale.isDefault) return pathWithoutLocale;
    return `/${locale.code.toLowerCase()}${pathWithoutLocale === '/' ? '' : pathWithoutLocale}`;
  };

  const alternateLinks = computed(() => {
    return (
      locales.value.map(locale => {
        return {
          rel: 'alternate',
          hreflang: locale.code,
          href: `${origin}${getPageLink(locale)}`,
        };
      }) || []
    );
  });

  const pageUrl = computed(() => {
    return `${origin}${route.fullPath}`;
  });

  onMounted(() => {
    if (appMode !== EnvName.PROD) {
      usePlug2Win();
    }
  });

  useHead({
    htmlAttrs: {
      lang: currentLocale.value?.code,
    },
    link: alternateLinks,
    meta: [
      {
        property: 'og:url',
        content: pageUrl,
      },
    ],
    bodyAttrs: {
      class: 'descendant',
    },
  });
</script>
